import { render, staticRenderFns } from "./ModalSuggestions.vue?vue&type=template&id=76c17fa0&scoped=true&"
import script from "./ModalSuggestions.vue?vue&type=script&lang=ts&"
export * from "./ModalSuggestions.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSuggestions.vue?vue&type=style&index=0&id=76c17fa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c17fa0",
  null
  
)

export default component.exports